/**
 * E2 pazarlamanın devamı ekran metinleri (Türkçe, resmî "siz"). Teknik altyapı adı geçmez; "izin" yalnız izin defterindeki
 * kayıttır ve hukuki metnin yerine geçmez.
 */
export const audienceText = {
  nav: {
    segments: 'Segmentler',
    rewin: 'Yeniden kazanım',
    quality: 'Kampanya kalitesi',
  },
  crumb: 'Pazarlama',
  common: {
    retry: 'Yeniden dene',
    loadFailed: 'Veriler yüklenemedi. Sayfayı yenileyip yeniden deneyin.',
    forbidden: 'Bu ekranı görmek için aday okuma yetkisi gerekli.',
    openList: (label: string, n: string) => `${label}: ${n} aday — listeyi aç`,
    capped: (n: string) => `${n} ve üzeri (sayım tavanı)`,
    importNote:
      'İçe aktarma, araştırma ya da bir kişinin bulunması iletişim izni oluşturmaz. İzin yalnız izin defterine kanıtıyla kaydedilir.',
    noSend:
      'Bu ekran ileti göndermez; temas işlemleri iletişim kurallarına (izin, sessiz saat, temas sınırı) tabidir.',
  },
  state: {
    allowed: 'İzinli',
    no_consent: 'İzin kaydı yok',
    blocked: 'Gönderim engelli',
  },
  segments: {
    title: 'Segmentler',
    description:
      'Kayıtlı aday listeleriniz hedef kitle olarak: her sayı, tıklayınca açılan listedeki aday sayısıdır; izin dağılımı da aynı listenin izne göre ayrılmış hâlidir.',
    listTitle: 'Kayıtlı aday listeleri',
    total: 'Segmentteki aday',
    distribution: 'Pazarlama iletişimi dağılımı',
    public: 'Herkese açık',
    private: 'Yalnız siz',
    unavailable:
      'Bu segment sizin için kullanılamıyor: görmediğiniz ya da silinmiş bir alana başvuruyor.',
    empty: 'Henüz kayıtlı aday listesi yok',
    emptyBody:
      'Aday listesinde süzgeç kurup "Listeyi kaydet" ile adlandırın; kayıtlı liste burada segment olarak görünür.',
    create: 'Aday listesinde segment oluştur',
    truncated: (n: number) => `İlk ${String(n)} kayıtlı liste gösteriliyor.`,
    openSegment: 'Segment listesini aç',
  },
  rewin: {
    title: 'Takip ve yeniden kazanım',
    description:
      'Uzun süredir temas edilmeyen, fırsatı kaybedilen ve niteliksiz bulunan adaylar. Satırdan sekansa ekleyin ya da takip görevi açın; engelli kişide işlem kapalıdır.',
    tabsLabel: 'Yeniden kazanım kümeleri',
    // G3: kanal özelindeki geri çekme yalnız o kanalı kapatır
    closedChannels: (names: string) => `Kapalı kanal (izin geri çekildi): ${names}`,
    dormantHint: (d: number) =>
      `Açık aday; son temas ${String(d)} günden eski (hiç temas yoksa ${String(d)} günden önce oluşturulmuş).`,
    lostHint: 'Dönüştüğü fırsat kazanılmadan kapandı.',
    unqualifiedHint: 'Durumu niteliksiz; dönüştürülmemiş.',
    statesLabel: 'Pazarlama iletişimi',
    empty: 'Bu kümede aday yok.',
    seeAll: (n: string) => `Tümünü listede gör (${n})`,
    lastContact: 'Son temas',
    never: 'Temas yok',
    frequency: 'Temas sıklığı',
    frequencyText: (d: number, pd: number, w: number, pw: number) =>
      `Son 24 saat ${String(d)}/${String(pd)} · son 7 gün ${String(w)}/${String(pw)}`,
    preview: 'Önizle',
    sequence: 'Sekansa ekle',
    task: 'Takip görevi',
    actions: (name: string) => `${name} için işlemler`,
    noWrite: 'Kayıt yazma yetkiniz olmadığı için işlem yapılamaz.',
    noConsentWarn: 'İzin kaydı yok: pazarlama amaçlı ileti göndermeyin.',
    chooseSequence: 'Sekans seçin',
    noSequences:
      'Etkin sekans yok. Sekansları Yönetim › Aday sekansları ekranından ayar yetkilisi tanımlar.',
    sequenceDialog: (name: string) => `${name} — sekansa ekle`,
    sequenceBody:
      'Aday seçilen sekansın ilk adımından başlar. Sekans adımları ekibinize hatırlatmadır; bu işlem ileti göndermez.',
    add: 'Sekansa ekle',
    cancel: 'Vazgeç',
    added: 'Aday sekansa eklendi.',
    already: 'Aday zaten bu sekansta; yeni çalışma açılmadı.',
    failed: 'İşlem tamamlanamadı.',
    taskCreated: 'Takip görevi oluşturuldu.',
    rowCount: (shown: number, total: string) =>
      `${total} adaydan ilk ${String(shown)} satır gösteriliyor.`,
  },
  contact: {
    title: 'İletişim izni ve temas sıklığı',
    channel: 'Kanal',
    marketing: 'Pazarlama',
    service: 'Hizmet iletişimi',
    since: (d: string) => `${d} itibarıyla`,
    source: 'Kaynak',
    suppressed: (reason: string, d: string) => `E-posta gönderim engelinde: ${reason} (${d})`,
    noEmail: 'Kayıtlı e-posta adresi yok.',
    notSuppressed: 'E-posta gönderim engeli yok.',
    frequency: 'Kendiliğinden temas (üç aktör toplamı)',
    capped: 'Temas sınırı dolu: yeni kendiliğinden temas engellenir.',
    notCapped: 'Temas sınırının altında.',
    loadFailed: 'İletişim izni bilgisi alınamadı.',
    blockTitle: 'Gönderim engeli',
    // G3 (sahip kararı C): kanal + amaç bazlı izin ile genel çıkış ayrımı
    channelNoteTitle: 'Kapalı kanal',
    via: {
      general: 'Genel iletişimden çıkış',
      unspecified: 'Kapsamı belirtilmemiş geri çekme (bütün kanallar kapalı sayılır)',
    },
    recordTitle: 'İzin kaydı ekle',
    recordHint:
      'Kaydı yalnız kişinin açık beyanına dayanarak ekleyin; kanıtı yazın. Hiçbir ileti gönderilmez.',
    action: 'İşlem',
    actions: {
      grant: 'Bu kanalda pazarlama izni verdi',
      withdraw_channel: 'Yalnız bu kanalda izni geri çekti',
      withdraw_general: 'Genel iletişimden çıktı (bütün kanallar)',
    },
    actionHint: {
      grant: 'Yalnız seçilen kanalı açar; diğer kanallara izin üretmez.',
      withdraw_channel: 'Yalnız seçilen kanalı kapatır; diğer kanalların durumu değişmez.',
      withdraw_general:
        'Bütün pazarlama kanallarını kapatır ve yeniden kazanım temasını durdurur. Sonradan yalnız açık bir kanal izni o kanalı açar.',
    },
    channelLabel: 'Kanal',
    evidence: 'Kanıt',
    evidenceHint: 'Ör. görüşme notu, form adı, izin metni sürümü (en az 3 karakter).',
    evidenceShort: 'Kanıt en az 3 karakter olmalı.',
    save: 'Kaydet',
    saved: 'İzin kaydı eklendi',
    failed: 'İzin kaydı eklenemedi.',
    forbidden: 'Bu kayda izin kaydı yazma yetkiniz yok.',
  },
  quality: {
    title: 'Kampanya–görüşme–satış kalitesi',
    description:
      'Dönemde gelen adayların bugünkü sonuçları kampanya ya da kaynak başına: gelen → görüşülen → nitelikli → fırsata dönüşen → kazanılan. Satırlar bağımsız durum sayılarıdır (huni değil).',
    filtersLabel: 'Kalite analizi süzgeçleri',
    period: 'Dönem',
    model: 'Atıf modeli',
    group: 'Gruplama',
    groupCampaign: 'Kampanyaya göre',
    groupSource: 'Kaynağa göre',
    apply: 'Uygula',
    periodText: (from: string, to: string, tz: string) =>
      `${from} – ${to} · ${tz} saat dilimi · adayın oluşturulma günü`,
    stage: {
      incoming: 'Gelen',
      contacted: 'Görüşülen',
      qualified: 'Nitelikli',
      converted: 'Fırsata dönüşen',
      won: 'Kazanılan',
    } as Record<string, string>,
    firstContact: 'İlk temas süresi (ortanca)',
    firstContactHint:
      'Adayın oluşturulmasından ilk tamamlanmış temas aktivitesine (görev dışı); yalnız temas edilen adaylarda ölçülür.',
    measured: (n: string) => `${n} adayda ölçüldü`,
    noMeasure: '— (temas edilen aday yok)',
    rate: (num: number, den: number, pct: string) => `${String(num)} / ${String(den)} · %${pct}`,
    rateNull: '— (hesaplanacak kayıt yok)',
    rateShort: {
      contactRate: 'Görüşme',
      qualifiedRate: 'Nitelik',
      opportunityRate: 'Fırsat',
      winRate: 'Fırsattan satış',
    } as Record<string, string>,
    totals: 'Toplam',
    name: 'Ad',
    empty: 'Bu dönemde aday yok.',
    note: 'Toplam satırı, çalışma merkezinin süreç görünümüyle aynı adayları sayar. Görüşülen = görülebilen, tamamlanmış temas aktivitesi olan aday.',
    certaintyTitle: 'Kaynak kesinliği',
    certaintyHint:
      'Seçilen modelin temasına göre. "Bilinmiyor": kaynağa dair kanıt yok ya da adayın teması yok — Google, Meta ya da organik diye tahmin edilmez.',
    unknownWarn: (n: string) =>
      `${n} adayın kaynağı kesin değil: kaynak/kampanya kırılımındaki bu adaylar tahmin değildir, ayrı okunmalıdır.`,
    spendTitle: 'Harcama kapsamı',
    spendMissing:
      'Harcama bağlantısı yok: maliyet ve reklam getirisi hesaplanmaz; tam getiri iddiası yoktur.',
    spendNoMatch:
      'Reklam hesabı bağlı, ancak bu dönemin kampanyalarıyla eşleşen harcama yok: getiri hesaplanmaz.',
    spendPartial: (pct: string) =>
      `Harcaması bilinen kampanyalar adayların %${pct} kadarını kapsıyor. Kapsam eksik olduğu için toplam reklam getirisi yazılmaz; getiri yalnız kapsamı tam kampanyada gösterilir.`,
    spendFull:
      'Harcama kapsamı tam (%100). Getiri kampanya raporunda harcama, para birimi ve dönem uyuştuğunda yazılır; ciro tahsilat değildir.',
    spendNoAccess: 'Harcama bilgisi reklam harcaması yetkisiyle görünür.',
    openReport: 'Kampanya raporunu aç',
    openQuality: 'Kalite analizini aç',
    noCampaign: 'Kampanyası bilinmeyen',
    minutes: (m: number) => {
      if (m < 60) return `${Math.round(m).toLocaleString('tr-TR')} dk`;
      if (m < 60 * 48)
        return `${(m / 60).toLocaleString('tr-TR', { maximumFractionDigits: 1 })} saat`;
      return `${(m / 1440).toLocaleString('tr-TR', { maximumFractionDigits: 1 })} gün`;
    },
  },
  confidence: {
    title: 'Veri güveni',
    description: 'Kaynak kesinliği ve harcama kapsamı: sonuçları okurken eksik olanı bilin.',
  },
  ads: {
    approval: 'Onay durumu',
    application: 'Reklam hesabında',
    explain:
      'Onaylanan istek reklam hesabında kendiliğinden UYGULANMAZ. "Uygulandı" yalnız yürütme sistemi platform yanıtıyla bildirdiğinde yazılır.',
  },
};
